<template>
    <div>
        <div class="x-stat">
            <a-row :gutter="24">
                <a-col :span="2">
                    <a-statistic title="会话量" :value="summary.conversationNum" />
                </a-col>
                <a-col :span="2">
                    <a-statistic title="收/发消息" :value="messageSummary" />
                </a-col>
                <a-col :span="2">
                    <a-statistic title="收礼金额" :value="summary.receiveGiftAmount" />
                </a-col>
                <a-col :span="2">
                    <a-statistic title="送礼金额" :value="summary.sendGiftAmount" />
                </a-col>
                <a-col :span="2">
                    <a-statistic title="消耗金币" :value="summary.expendGold" />
                </a-col>
                <a-col :span="2">
                    <a-statistic title="获得积分" :value="summary.incomeScore" />
                </a-col>
            </a-row>
        </div>

        <a-card :bordered="false">
            <div class="x-filter">
                <a-form layout="inline">
                    <a-row :gutter="24">
                        <a-col :span="4">
                            <a-form-item label="用户名">
                                <a-input v-model="queryParams.username" placeholder="用户名/登录名" allow-clear />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="时间">
                                <a-range-picker
                                    v-model="statDate"
                                    style="width: 100%"
                                    @change="onStatDate"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="4">
                            <span class="x-filter-submit-box">
                                <a-button type="primary" @click="search">查询</a-button>
                                <a-button style="margin-left: 8px" @click="reset">重置</a-button>
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>

            <a-table
                :rowKey="record => record.id"
                :columns="tableColumns"
                :loading="tableLoading"
                :dataSource="tableData"
                :pagination="false"
                bordered
                size="middle"
            >
                <span slot="receiveGift" slot-scope="record">
                    {{ record.receiveGiftNum }} / {{ record.receiveGiftAmount }}
                </span>
                <span slot="sendGift" slot-scope="record">
                    {{ record.sendGiftNum }} / {{ record.sendGiftAmount }}
                </span>
            </a-table>

            <div class="x-pagination">
                <a-pagination
                    v-model="pageIndex"
                    :pageSize="pageSize"
                    :total="totalRow"
                    :hideOnSinglePage="true"
                    show-less-items
                    @change="pageChange"
                />
            </div>
        </a-card>
    </div>
</template>

<script>
import moment from 'moment';
import { statPerformerList } from '@/api/statistics/performer';

const emptySummary = () => ({
    conversationNum: 0,
    receiveMessageNum: 0,
    sendMessageNum: 0,
    receiveGiftNum: 0,
    receiveGiftAmount: 0,
    sendGiftNum: 0,
    sendGiftAmount: 0,
    expendGold: 0,
    incomeScore: 0
});

const tableColumns = [
    {
        title: '日期',
        dataIndex: 'statDate',
        width: 80
    },
    {
        title: '用户名',
        dataIndex: 'performerName',
        width: 100
    },
    {
        title: '会话量',
        dataIndex: 'conversationNum',
        width: 90,
        align: 'center'
    },
    {
        title: '收消息',
        dataIndex: 'receiveMessageNum',
        width: 90,
        align: 'center'
    },
    {
        title: '发消息',
        dataIndex: 'sendMessageNum',
        width: 90,
        align: 'center'
    },
    {
        title: '收礼',
        scopedSlots: { customRender: 'receiveGift' },
        width: 130,
        align: 'center'
    },
    {
        title: '送礼',
        scopedSlots: { customRender: 'sendGift' },
        width: 130,
        align: 'center'
    },
    {
        title: '消耗金币',
        dataIndex: 'expendGold',
        width: 100,
        align: 'center'
    },
    {
        title: '获得积分',
        dataIndex: 'incomeScore',
        width: 100,
        align: 'center'
    },
    {
        title: '创建时间',
        dataIndex: 'created',
        width: 170
    }
];

export default {
    name: 'PerformerStat',
    data() {
        return {
            tableColumns,
            tableData: [],
            tableLoading: false,
            totalRow: 0,
            pageSize: 20,
            pageIndex: 1,
            queryParams: {},
            statDate: [],
            summary: emptySummary()
        };
    },
    computed: {
        messageSummary() {
            const s = this.summary;
            return `${s.receiveMessageNum}/${s.sendMessageNum}`;
        }
    },
    created() {
        this.fetchTableData();
    },
    methods: {
        fetchTableData() {
            this.tableLoading = true;
            const params = {
                ...this.queryParams,
                page: this.pageIndex,
                pageSize: this.pageSize
            };
            return statPerformerList(params).then(res => {
                this.tableData = res.data.recordList || [];
                this.totalRow = res.data.totalRow || 0;
                this.summary = {
                    ...emptySummary(),
                    ...(res.data.summary || {})
                };
                this.tableLoading = false;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        search() {
            this.pageIndex = 1;
            this.fetchTableData();
        },
        reset() {
            this.queryParams = {};
            this.statDate = [];
            this.pageIndex = 1;
            this.fetchTableData();
        },
        pageChange(page) {
            this.pageIndex = page;
            this.fetchTableData();
        },
        onStatDate(values) {
            if (values && values.length === 2) {
                this.queryParams.startStatDate = moment(values[0]).format('YYYY-MM-DD');
                this.queryParams.endStatDate = moment(values[1]).format('YYYY-MM-DD');
            } else {
                delete this.queryParams.startStatDate;
                delete this.queryParams.endStatDate;
            }
        }
    }
};
</script>
